import { connect } from "react-redux";
import { getListTinChap } from "actions/TinChap";
import { showXoaHopDong } from "actions/XoaHopDong";
import {
  getLanDongLaiChoVay,
  getLaiDenNgayChoVay,
  getLichSuGiaHanChoVay,
  postGiaHanChoVay,
  getLichSuTraBotGocChoVay,
  postTraBotGocChoVay,
  getLichSuVayThemChoVay,
  postVayThemChoVay,
  postThayDoiLaiSuatChoVay,
  postTatToanChoVay,
  deleteTraBotGocChoVay,
  deleteVayThemChoVay,
  getTatToanChoVay,
} from "actions/QuanLyChoVay";
import {
  postThanhToanChoVay,
  deleteThanhToanChoVay,
  updateObjThanhToan,
  postThanhToanAllChoVay,
} from "actions/QuanLyThuChi";
import { getComboUser } from "actions/User";
import { getConfig } from "actions/CauHinh";
import { showInMaVachTaiSan } from "actions/InMaVachTaiSan";
import { showModalGuiEmail } from "actions/GuiEmail";
import { showModalGuiTinNhan } from "actions/GuiTinNhan";
import { showFormTinChap } from "actions/ThemMoiTinChap";
import { showModalLoaiTaiSan } from "actions/LoaiTaiSan";
import { showInPhieuThuChi } from "actions/InThuChi";
import { getPhanQuyenTinChap } from "actions/PhanQuyen";
// import TinChap from "components/TinChap";
import TinChapNoXau from "components/DanhSachNoXau/TinChap";

const mapStateToProps = (state) => ({
  camdo: state.camdo,
  quanlychovay: state.quanlychovay,
  quanlythuchi: state.quanlythuchi,
  user: state.user,
  cauhinh: state.cauhinh,
  themmoicamdo: state.themmoicamdo,
  phanquyen: state.phanquyen,
  loaitaisan: state.loaitaisan,
  tinchap: state.tinchap,
  themmoitinchap: state.themmoitinchap,
  inthuchi: state.inthuchi,
});

const mapDispatchToProps = (dispatch) => ({
  // getListTinChap: (dataSearch) => dispatch(getListTinChap(dataSearch)),
    getListTinChap: (dataSearch) => {
    const newDataSearch = {
      ...dataSearch,
      debt: 50, // Gán lại luôn
    };
    dispatch(getListTinChap(newDataSearch));
  },
  getLanDongLaiChoVay: (dataSearch) =>
    dispatch(getLanDongLaiChoVay(dataSearch)),
  getLaiDenNgayChoVay: (data) => dispatch(getLaiDenNgayChoVay(data)),
  postThanhToanChoVay: (dataPost, dataSearch) =>
    dispatch(postThanhToanChoVay(dataPost, dataSearch)),
  deleteThanhToanChoVay: (dataPost, dataSearch) =>
    dispatch(deleteThanhToanChoVay(dataPost, dataSearch)),
  updateObjThanhToan: (dataPost) => dispatch(updateObjThanhToan(dataPost)),
  postThanhToanAllChoVay: (dataPost, dataSearch) =>
    dispatch(postThanhToanAllChoVay(dataPost, dataSearch)),
  getComboUser: () => dispatch(getComboUser()),
  postGiaHanChoVay: (dataPost, dataSearch) =>
    dispatch(postGiaHanChoVay(dataPost, dataSearch)),
  getLichSuGiaHanChoVay: (dataSearch) =>
    dispatch(getLichSuGiaHanChoVay(dataSearch)),
  postTraBotGocChoVay: (dataPost, dataSearch) =>
    dispatch(postTraBotGocChoVay(dataPost, dataSearch)),
  deleteTraBotGocChoVay: (dataPost, dataSearch) =>
    dispatch(deleteTraBotGocChoVay(dataPost, dataSearch)),
  getLichSuTraBotGocChoVay: (dataSearch) =>
    dispatch(getLichSuTraBotGocChoVay(dataSearch)),
  postVayThemChoVay: (dataPost, dataSearch) =>
    dispatch(postVayThemChoVay(dataPost, dataSearch)),
  postThayDoiLaiSuatChoVay: (dataPost, dataSearch) =>
    dispatch(postThayDoiLaiSuatChoVay(dataPost, dataSearch)),
  deleteVayThemChoVay: (dataPost, dataSearch) =>
    dispatch(deleteVayThemChoVay(dataPost, dataSearch)),
  getLichSuVayThemChoVay: (dataSearch) =>
    dispatch(getLichSuVayThemChoVay(dataSearch)),
  postTatToanChoVay: (dataPost) => dispatch(postTatToanChoVay(dataPost)),
  getTatToanChoVay: (dataPost) => dispatch(getTatToanChoVay(dataPost)),
  getConfig: () => dispatch(getConfig()),
  showXoaHopDong: () => dispatch(showXoaHopDong()),
  showInMaVachTaiSan: () => dispatch(showInMaVachTaiSan()),
  showModalGuiEmail: () => dispatch(showModalGuiEmail()),
  showModalGuiTinNhan: () => dispatch(showModalGuiTinNhan()),
  showFormTinChap: (data) => dispatch(showFormTinChap(data)),
  getPhanQuyenTinChap: (data) => dispatch(getPhanQuyenTinChap(data)),
  showModalLoaiTaiSan: (data) => dispatch(showModalLoaiTaiSan(data)),
  showInPhieuThuChi: (thuChiId) => dispatch(showInPhieuThuChi(thuChiId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TinChapNoXau);
